import { React, useEffect, useState } from 'react'
import { host } from '../script/variables'
import InfiniteScroll from 'react-infinite-scroll-component'
import { Link } from 'react-router-dom'
import { checkLogin } from '../script/variables'
import Login from '../Login'

/* ─── Inline styles (no extra CSS file needed) ─────────────────────────── */
const S = {
  root: {
    fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
    background: '#0f0f13',
    color: '#e8e8f0',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    borderRadius: '16px',
  },
  header: {
    padding: '20px 20px 14px',
    borderBottom: '1px solid rgba(255,255,255,0.07)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  bellIcon: {
    width: 32,
    height: 32,
    borderRadius: '10px',
    background: 'linear-gradient(135deg, #6c63ff, #a78bfa)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 15,
    flexShrink: 0,
  },
  title: {
    margin: 0,
    fontSize: '1rem',
    fontWeight: 700,
    letterSpacing: '-0.01em',
    color: '#f0f0f8',
  },
  badge: {
    background: '#6c63ff',
    color: '#fff',
    borderRadius: '20px',
    fontSize: '0.68rem',
    fontWeight: 700,
    padding: '2px 8px',
    marginLeft: 6,
  },
  markAll: {
    background: 'none',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: '8px',
    color: '#a0a0c0',
    fontSize: '0.72rem',
    padding: '5px 10px',
    cursor: 'pointer',
    transition: 'all 0.15s',
  },
  scrollWrapper: {
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  item: (unread) => ({
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    padding: '14px 20px',
    borderBottom: '1px solid rgba(255,255,255,0.05)',
    textDecoration: 'none',
    color: 'inherit',
    background: unread ? 'rgba(108,99,255,0.06)' : 'transparent',
    transition: 'background 0.15s',
    cursor: 'pointer',
    position: 'relative',
  }),
  unreadDot: {
    position: 'absolute',
    left: 8,
    top: '50%',
    transform: 'translateY(-50%)',
    width: 6,
    height: 6,
    borderRadius: '50%',
    background: '#6c63ff',
    flexShrink: 0,
  },
  avatar: (color) => ({
    width: 38,
    height: 38,
    borderRadius: '12px',
    background: color,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '0.85rem',
    fontWeight: 700,
    color: '#fff',
    flexShrink: 0,
    letterSpacing: '0.02em',
  }),
  body: {
    flex: 1,
    minWidth: 0,
  },
  text: {
    margin: '0 0 4px',
    fontSize: '0.83rem',
    lineHeight: 1.45,
    color: '#d0d0e8',
  },
  username: {
    color: '#a78bfa',
    fontWeight: 600,
  },
  action: {
    color: '#e8e8f0',
  },
  time: {
    fontSize: '0.72rem',
    color: '#606080',
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  loaderWrap: {
    display: 'flex',
    justifyContent: 'center',
    padding: '16px 0',
  },
  spinner: {
    width: 22,
    height: 22,
    border: '2px solid rgba(255,255,255,0.08)',
    borderTop: '2px solid #6c63ff',
    borderRadius: '50%',
    animation: 'spin 0.7s linear infinite',
  },
  endMsg: {
    textAlign: 'center',
    padding: '16px',
    fontSize: '0.78rem',
    color: '#404060',
  },
  empty: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    padding: '40px 20px',
    color: '#505070',
  },
  emptyIcon: {
    fontSize: 36,
    opacity: 0.4,
  },
}

/* ─── Avatar colour from username ──────────────────────────────────────── */
const AVATAR_COLORS = [
  'linear-gradient(135deg,#6c63ff,#a78bfa)',
  'linear-gradient(135deg,#f59e0b,#fbbf24)',
  'linear-gradient(135deg,#10b981,#34d399)',
  'linear-gradient(135deg,#ef4444,#f87171)',
  'linear-gradient(135deg,#3b82f6,#60a5fa)',
  'linear-gradient(135deg,#ec4899,#f472b6)',
]
const avatarColor = (name = '') => {
  let hash = 0
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash)
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length]
}
const initials = (name = '') =>
  name
    .split(' ')
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase() || '?'

/* ─── timeAgo ───────────────────────────────────────────────────────────── */
function timeAgo(ts) {
  const diff = Date.now() - new Date(ts)
  const s = Math.floor(diff / 1000)
  const m = Math.floor(s / 60)
  const h = Math.floor(m / 60)
  const d = Math.floor(h / 24)
  const w = Math.floor(d / 7)
  const mo = Math.floor(d / 30)
  if (mo > 0) return `${mo}mo ago`
  if (w > 0) return `${w}w ago`
  if (d > 0) return `${d}d ago`
  if (h > 0) return `${h}h ago`
  if (m > 0) return `${m}m ago`
  return s <= 5 ? 'just now' : `${s}s ago`
}

/* ─── Component ─────────────────────────────────────────────────────────── */
const Notification = () => {
  const [notification, setNotification] = useState([])
  const [page, setPage] = useState(1)
  const [hasMore, setHasMore] = useState(true)
  const [isLogin, setIsLogin] = useState(false)
  const [readIds, setReadIds] = useState(new Set())
  const [loading, setLoading] = useState(false)

  const unreadCount = notification.filter((n) => !readIds.has(n._id)).length

  const markAllRead = () => {
    setReadIds(new Set(notification.map((n) => n._id)))
  }

  const markRead = (id) => {
    setReadIds((prev) => new Set([...prev, id]))
  }

  const fetchNotification = async () => {
    if (loading) return
    setLoading(true)
    try {
      const token = localStorage.getItem('token')
      const response = await fetch(`${host}/masala/notification?pno=${page}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${token}`,
        },
      })
      if (response.ok) {
        const data = await response.json()
        setPage((p) => p + 1)
        if (data.length < 5) setHasMore(false)
        setNotification((prev) => (page === 1 ? data : [...prev, ...data]))
      }
    } catch {
      // silent
    } finally {
      setLoading(false)
    }
  }

  const runcheck = async () => {
    const logg = await checkLogin()
    setIsLogin(logg)
  }

  useEffect(() => {
    setPage(1)
    runcheck()
  }, [])

  useEffect(() => {
    if (isLogin) fetchNotification()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLogin])

  /* inject spin keyframe once */
  useEffect(() => {
    if (document.getElementById('notif-spin-style')) return
    const style = document.createElement('style')
    style.id = 'notif-spin-style'
    style.textContent = `
      @keyframes spin { to { transform: rotate(360deg); } }
      @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');
      .notif-item:hover { background: rgba(108,99,255,0.1) !important; }
      .notif-scroll::-webkit-scrollbar { width: 4px; }
      .notif-scroll::-webkit-scrollbar-track { background: transparent; }
      .notif-scroll::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.08); border-radius: 4px; }
      .mark-all-btn:hover { background: rgba(108,99,255,0.15) !important; color: #a78bfa !important; border-color: rgba(108,99,255,0.4) !important; }
    `
    document.head.appendChild(style)
  }, [])

  if (!isLogin) return <Login setIsLogin={setIsLogin} />

  return (
    <div style={S.root}>
      {/* Header */}
      <div style={S.header}>
        <div style={S.headerLeft}>
          <div style={S.bellIcon}>🔔</div>
          <h2 style={S.title}>
            Notifications
            {unreadCount > 0 && <span style={S.badge}>{unreadCount}</span>}
          </h2>
        </div>
        {unreadCount > 0 && (
          <button className="mark-all-btn" style={S.markAll} onClick={markAllRead}>
            Mark all read
          </button>
        )}
      </div>

      {/* List */}
      {notification.length === 0 && !loading ? (
        <div style={S.empty}>
          <span style={S.emptyIcon}>🔕</span>
          <span style={{ fontWeight: 500 }}>No notifications yet</span>
          <span style={{ fontSize: '0.78rem' }}>We'll let you know when something happens</span>
        </div>
      ) : (
        <div className="notif-scroll" style={S.scrollWrapper} id="notif-scroll-target">
          <InfiniteScroll
            dataLength={notification.length}
            next={fetchNotification}
            hasMore={hasMore}
            scrollableTarget="notif-scroll-target"
            loader={
              <div style={S.loaderWrap}>
                <div style={S.spinner} />
              </div>
            }
            endMessage={
              <p style={S.endMsg}>✦ You're all caught up ✦</p>
            }
          >
            {notification.map((item) => {
              const unread = !readIds.has(item._id)
              const name = item.performerDetails?.username || '?'
              return (
                <Link
                  to={item.url}
                  key={item._id}
                  className="notif-item"
                  style={S.item(unread)}
                  onClick={() => markRead(item._id)}
                >
                  {unread && <span style={S.unreadDot} />}

                  {/* Avatar */}
                  <div style={S.avatar(avatarColor(name))}>
                    {initials(name)}
                  </div>

                  {/* Body */}
                  <div style={S.body}>
                    <p style={S.text}>
                      <span style={S.username}>@{name}</span>{' '}
                      <span style={S.action}>{item.action}</span>
                      {' to your '}
                      <span style={{ color: '#c4b5fd', fontWeight: 500 }}>{item.content}</span>
                    </p>
                    <span style={S.time}>
                      <svg width="10" height="10" viewBox="0 0 12 12" fill="none">
                        <circle cx="6" cy="6" r="5" stroke="#606080" strokeWidth="1.5"/>
                        <path d="M6 3.5V6l1.5 1.5" stroke="#606080" strokeWidth="1.5" strokeLinecap="round"/>
                      </svg>
                      {timeAgo(item.createdAt)}
                    </span>
                  </div>
                </Link>
              )
            })}
          </InfiniteScroll>
        </div>
      )}
    </div>
  )
}

export default Notification